import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-person",
  "use": "circle-person-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"circle-person\"><rect width=\"32\" height=\"32\" rx=\"16\" fill=\"#6F8EDB\" /><path d=\"M16 19c-3.338 0-11 1.563-11 4.667C5 27 11 30 16 30s11-3 11-6.333C27 20.563 19.337 19 16 19z\" fill=\"#252E3D\" /><path d=\"M16 17c2.762 0 5-2.238 5-5s-2.238-5-5-5-5 2.238-5 5 2.238 5 5 5z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol